export default "__VITE_ASSET__CVbDltCq__"